import {
  GET_ALL_CLIENTS_REQUEST,
  GET_ALL_CLIENTS_SUCCESS,
  GET_ALL_CLIENTS_FAIL,
  GET_CLIENT_BY_ID_REQUEST,
  GET_CLIENT_BY_ID_SUCCESS,
  GET_CLIENT_BY_ID_FAIL,
  ADD_CLIENT_REQUEST,
  ADD_CLIENT_SUCCESS,
  ADD_CLIENT_FAIL,
  UPDATE_CLIENT_STATUS_REQUEST,
  UPDATE_CLIENT_STATUS_SUCCESS,
  UPDATE_CLIENT_STATUS_FAIL
} from '../constants/ClientConstants';

const initialState = {
  responseBody: null,
  loading: false,
  msg: null,
};

export const GetAllClients = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CLIENTS_REQUEST:
      return { ...state, loading: true, msg: null };

    case GET_ALL_CLIENTS_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case GET_ALL_CLIENTS_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

export const GetClientById = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_BY_ID_REQUEST:
      return { ...state, loading: true, msg: null };

    case GET_CLIENT_BY_ID_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case GET_CLIENT_BY_ID_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

export const AddClient = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CLIENT_REQUEST:
      return { ...state, loading: true, msg: null };

    case ADD_CLIENT_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case ADD_CLIENT_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

// NEW: Update Client Status Reducer
export const UpdateClientStatus = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CLIENT_STATUS_REQUEST:
      return { ...state, loading: true, msg: null };

    case UPDATE_CLIENT_STATUS_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case UPDATE_CLIENT_STATUS_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

// ========== SELECTORS ==========
export const selectAllClientsData = (state) => state.allclients?.responseBody;
export const selectAllClientsLoading = (state) => state.allclients?.loading;
export const selectAllClientsError = (state) => state.allclients?.msg;

export const selectAddClientData = (state) => state.addclient?.responseBody;
export const selectAddClientLoading = (state) => state.addclient?.loading;
export const selectAddClientError = (state) => state.addclient?.msg;

export const selectClientByIdData = (state) => state.clientbyid?.responseBody;
export const selectClientByIdLoading = (state) => state.clientbyid?.loading;
export const selectClientByIdError = (state) => state.clientbyid?.msg;

export const selectUpdateClientStatusData = (state) => state.updateclientstatus?.responseBody;  
export const selectUpdateClientStatusLoading = (state) => state.updateclientstatus?.loading;  
export const selectUpdateClientStatusError = (state) => state.updateclientstatus?.msg;